var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.68067 0.12765C1.49305 -0.0599714 1.16712 -0.0382384 0.952703 0.176177L0.176194 0.952687C-0.0382384 1.16712 -0.0599714 1.49305 0.12765 1.68067L4.44699 6.00001L0.12765 10.3193C-0.0599714 10.507 -0.0382384 10.8329 0.176177 11.0473L0.952687 11.8238C1.16712 12.0382 1.49305 12.06 1.68067 11.8723L6.00001 7.55303L10.3193 11.8723C10.507 12.06 10.8329 12.0382 11.0473 11.8238L11.8238 11.0473C12.0382 10.8329 12.06 10.507 11.8723 10.3193L7.55303 6.00001L11.8723 1.68067C12.06 1.49305 12.0382 1.16712 11.8238 0.952687L11.0473 0.176177C10.8329 -0.0382384 10.507 -0.0599714 10.3193 0.12765L6.00001 4.44699L1.68067 0.12765Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.27269a5b7e2eb63942e49404bfc37ed9.svg";
export { ForwardRef as ReactComponent };